var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOracle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_32)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.575 19.575C3.34875 19.575 0 16.146 0 12C0 7.77375 3.42863 4.425 7.575 4.425H16.425C20.6513 4.425 24 7.854 24 12C24 16.2263 20.5714 19.575 16.425 19.575H7.575ZM16.266 16.8638C18.9773 16.8638 21.2096 14.6314 21.2096 11.9201C21.2096 9.20888 18.9773 6.9765 16.266 6.9765H7.81388C5.10262 6.9765 2.87025 9.20888 2.87025 11.9201C2.87025 14.6314 5.103 16.8638 7.81388 16.8638H16.266Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOracle);
export default __webpack_public_path__ + "static/media/oracle.19619cb9a04cb53173e07df4c431a739.svg";
export { ForwardRef as ReactComponent };